<template lang="pug">
.page
  .flexRight
    //- 抄表数据查询
    .info-box(v-for="item in statDatas")
      .desc-info {{item.desc}}
      .import-info {{item.num}}
      .import-info_percent(v-if="item.percent") {{item.percent.desc}}&nbsp;&nbsp;&nbsp;{{item.percent.num}}%
  Tab(:tabList="tabList"
    :path="path"
    ref="tabBox")
    DataTablePage(
      ref="historyTable"
      title="用水历史"
      label="用水"
      slot="realData"
      v-if="tabName === 'realData'"
      class="dataTable"
      hoverBy="dataLogId"
      :resource="resource"
      :operation="operation"
      :operationWidth="80"
      :updateList="updateList"
      :tableFullList="tableRealList"
      :tableInitList="tableRealList"
      :filterFullList="filterFullList"
      :filterInitList="filterInitList"
      :filterByInit="filterByInit"
      :columns="columns"
      @getData="getCountInitStatus")
    DataTablePage(
      ref="dayTable"
      title=""
      slot="dayData"
      v-if="tabName === 'dayData'"
      class="dataTable"
      resource="/nb/history/findReading/day"
      :operation="[]"
      :operationWidth="0"
      :tableFullList="tableDayList"
      :tableInitList="tableDayList"
      :filterFullList="filterDateList"
      :filterInitList="filterDateList"
      :filterByInit="filterDayByInit"
      :columns="columns")
    DataTablePage(
      ref="monthTable"
      title=""
      slot="monthData"
      v-if="tabName === 'monthData'"
      class="dataTable"
      resource="/nb/history/findReading/month"
      :operation="[]"
      :operationWidth="0"
      :tableFullList="tableDayList"
      :tableInitList="tableDayList"
      :filterFullList="filterDateList"
      :filterInitList="filterDateList"
      :filterByInit="filterDayByInit"
      :columns="columns")
</template>
<script>
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { fetchUpdate } from '@/utils/api'
import Tab from '@/components/Tab'
import { expire } from '@/utils/auth'
export default {
  name: 'WaterList',
  components: {
    DataTablePage,
    Tab
  },
  data () {
    const tabList = [{label: '实时抄表数据', name: 'realData'}]
    return {
      operation: [{
        label: '查看抄表历史',
        icon: 'meterRecords',
        tooltip: true,
        func ({funcProps}) {
          const { data } = funcProps
          const counterId = data.counterId
          this.$router.push({
            path: `/nb/waterAllHistory/${counterId}`
          })
        }
      }],
      copyTableData: [], // table列表数据
      checkGroup: [], // 勾选的数组
      /**
      * 点抄参数
      **/
      readingstatus: 'ready',
      statusType: 'success',
      statusText: '点抄', // 点抄按钮名称
      counterId: 0,
      resource: '/nb/history/findReading',
      tableFullList: ['hno', 'hname', 'counterCode', 'areaPathName', 'num', 'image', 'time', 'addr', 'phone', 'mobile'],
      tableInitList: ['hno', 'hname', 'counterCode', 'areaPathName', 'num', 'image', 'time', 'addr', 'phone', 'mobile'],
      tableRealList: ['hno', 'hname', 'counterCode', 'areaPathName', 'num', 'image', 'time', 'addr', 'phone', 'mobile'],
      tableDayList: ['hno', 'hname', 'counterCode', 'areaPathName', 'num', 'phone', 'mobile', 'copyTime', 'period', 'addr'],
      filterFullList: ['areaId', 'time', 'hno'],
      filterInitList: ['areaId', 'time', 'hno'],
      filterDateList: ['copyTime', 'wave'],
      filterByInit: [{
        name: 'time',
        type: 'ge',
        value: this.$moment().startOf('month').format('x')
      }, {
        name: 'time',
        type: 'le',
        value: this.$moment().endOf('month').format('x')
      }],
      filterDayByInit: [{
        name: 'period',
        type: 'ge',
        value: this.$moment().startOf('month').format('x')
      }, {
        name: 'period',
        type: 'le',
        value: this.$moment().endOf('month').format('x')
      }],
      updateList: ['num'],
      columns: {
        ...columns,
        hno: {
          label: '户号',
          type: 'input',
          // link: true,
          // link: `/telnetReading/history?counterId=${this.$refs.historyTable.counterId}`,
          width: 110,
          form: {
            type: 'input',
            size: 10,
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          },
          filter: {
            type: 'input',
            width: 100,
            like: true
          }
        },
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${data}" style="height:24px"></img>`
          }
        },
        readingStatus: {
          label: '点抄状态',
          type: 'select',
          width: 100,
          options: [{
            label: '允许点抄',
            value: 'ready'
          }, {
            label: '正在点抄',
            value: 'processing'
          }, {
            label: '点抄失败',
            value: 'failed'
          }, {
            label: '点抄成功',
            value: 'finish'
          }]
        }
      },
      updateButtonList: [{
        name: 'submit',
        label: '编辑',
        validate: true,
        funcProps: {
          table: this
        },
        func ({funcProps}) {
          const { table } = funcProps
          const { formValues } = funcProps.form
          fetchUpdate({
            resource: '/nb/history/base',
            id: formValues.id,
            data: formValues
          }).then(res => {
            if (res) {
              table.$nextTick(() => {
                const dataTable = table.$refs.historyTable
                dataTable.getData()
                dataTable.dialogVisible = false
                table.$swal(`${res.message}`, '', 'success')
                // table.$message({ type: 'success', showClose: true, message: res.message })
              })
            }
          })
        }
      }],
      tabList: tabList,
      tabName: this.$route.query.state || tabList[0].name,
      path: `/nb/waterAllLists`,
      /* 数据统计 */
      statDatas: [{
        desc: '当前抄表总数',
        num: 0
      }]
    }
  },
  watch: {
    statusType (status) {
      this.renderRecord(status)
    },
    $route (to, form) {
      const { state } = to.query
      this.tabName = state || this.tabList[0].name
      this.path = `/nb/waterAllLists`
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    // 初始化时获取点抄状态
    getCountInitStatus (data) {
      const {allNum} = data
      this.copyTableData = data.data
      const allData = {...this.statDatas[0], num: allNum}
      this.statDatas = [allData]
    },
    // 刷新table
    refreshTable () {
      this.$refs.historyTable.getData()
    },
    /*
    *返回点抄状态
    */
    renderRecord (status) {
      const statusText = status === 'processing' ? '点抄中'
            : status === 'failed' ? '点抄失败'
            : status === 'finish' ? '点抄完成'
            : '点抄' // 按钮显示的内容
      const statusType = status === 'processing' ? 'info'
            : status === 'failed' ? 'danger'
            : status === 'finish' ? 'success'
            : 'default' // 按钮显示类型
      this.statusText = statusText
      this.readingstatus = status
      this.statusType = statusType
      // console.info('点抄状态: ', statusType, statusText, status)
    },
    renderTableData (data) {
      this.copyTableData = data.data
    }
  },
  destroyed () {
    // clearTimeout(this.progressListener)
  }
}
</script>
<style lang="sass" scoped>
.page
  display: flex
  flex-direction: column
  height: 100%
.main
  padding-top: 0
  .main
    padding: 0
.toolBar
  display: inline-block
  margin-top: 5px
  .header-bottom
    margin-right: 3px
.flexRight
  display: flex
  padding: 0 20px
  .info-box
    background: #fff
    border-radius: 5px
    box-shadow: 0px 1px 2px #ddd
    padding: 5px 20px
    margin-right: 10px
    margin-top: 10px
    min-width: 200px
    line-height: 30px
    .desc-info
      color: #8391a5
    .import-info
      font-size: 24px
    .import-info_percent
      border-top: 1px dotted #ddd
      text-align: right
</style>


// WEBPACK FOOTER //
// WaterAllLists.vue?4dc71dce